<template>
  <div class="full-body footer" flex fic fjc>
    <div class="w8 mw11 footer-layout" flex fis fjb>
      <div class="footer-links" flex fic fjb>
        <div>
          <a href="/agree">서비스 이용약관</a>
          <span class="divider">|</span>
          <a href="/privacy">개인정보처리방침</a>
        </div>
        <div>
          <a href="https://twitter.com/UPICK_twt">
            <img src="/images/twitter_icon.webp" alt="twitter" />
          </a>
          <a
              href="https://www.youtube.com/channel/UCHYS3hBmHNv_-Dj4f_m-nDA"
              class="ml20"
          >
            <img src="/images/youtube.webp" alt="youtube" />
          </a>
        </div>
      </div>
      <div class="box1">
        <div class="fs-14 bold">(주) 어헤드 코리아</div>
        <div class="mt8">
          주소 : 서울특별시 강남구 도산대로 12길 25-1, 5층
          <div>사업자등록번호 :784-88-02180</div>
          <div>제 2022-서울강남-05684 호</div>
        </div>
        <div class="mt20 pt20d pt20t pt2m">이메일 : help.upick@gmail.com</div>
        <div class="mt20 pt20 bold">
          Copyright (c) 2022 AHEAD Korea Corp. All rights reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterLayout',
};
</script>